export default __webpack_public_path__ + "static/media/lichtschriftlogo.acc74ea4.png";